'use memo'

import { DeleteOutlined, EditOutlined, MailOutlined } from '@ant-design/icons'
import type { MenuProps } from 'antd'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import RowActionsCell from 'src/features/competition/operations/components/cells/RowActionsCell'
import type { FamilyMember } from '../../hooks/useFamilyMembers'
import { familyRowActions } from '../utils/familyRowActions'
import type { FamilyRowAction } from '../utils/familyRowActions'

interface FamilyRowActionsProps {
  member: FamilyMember
  onSelect: (action: FamilyRowAction) => void
}

const MENU_ITEMS: Record<
  FamilyRowAction,
  NonNullable<MenuProps['items']>[number]
> = {
  resend: {
    key: 'resend',
    icon: <MailOutlined />,
    label: capitalizeWords('Resend Invite'),
  },
  edit: { key: 'edit', icon: <EditOutlined />, label: capitalizeWords('Edit') },
  delete: {
    key: 'delete',
    icon: <DeleteOutlined />,
    label: capitalizeWords('Delete'),
    danger: true,
  },
}

/** The ⋯ menu for a family row: Resend Invite (pending only), Edit, Delete. */
const FamilyRowActions = ({ member, onSelect }: FamilyRowActionsProps) => {
  const items = familyRowActions(member).map((action) => MENU_ITEMS[action])

  return (
    <RowActionsCell
      items={items}
      onSelect={(key) => onSelect(key as FamilyRowAction)}
      label={`${member.name} actions`}
    />
  )
}

export default FamilyRowActions
